import React from 'react';
import './App.css';
import UniversalHeader from './UniversalHeader';
import { useNavigate } from 'react-router-dom';

function StatCard({ title, value, pill, align = 'left' }) {
  return (
    <div className="dash-card dash-card--stat">
      <div className="dash-card-header">
        <p className="dash-card-label">{title}</p>
        {pill && <span className="dash-pill">{pill}</span>}
      </div>
      <p className={`dash-card-value dash-card-value--${align}`}>{value}</p>
    </div>
  );
}

function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="dashboard-root">
      <UniversalHeader />
      {/* Top navigation */}
      <header className="dash-topbar">
        <div className="dash-topbar-left">
          <div className="dash-logo-mark">RO</div>
          <div className="dash-topbar-text">
            <span className="dash-topbar-title">ODUS</span>
            <span className="dash-topbar-subtitle">Portfolio overview</span>
          </div>
        </div>

        <div className="dash-topbar-right">
          <button className="dash-icon-btn" aria-label="Notifications">
            <span className="dash-icon-badge" />
            <span className="dash-icon">🔔</span>
          </button>
          <button className="dash-icon-btn" aria-label="Settings">
            <span className="dash-icon">⚙️</span>
          </button>
          <div className="dash-profile">
            <div className="dash-profile-avatar">SL</div>
            <div className="dash-profile-meta">
              <span className="dash-profile-name">Shuaib</span>
              <span className="dash-profile-role">Portfolio Admin</span>
            </div>
          </div>
        </div>
      </header>

      {/* Content layout */}
      <main className="dash-layout">
        <section className="dash-main">
          {/* Summary cards row */}
          <div className="dash-grid dash-grid--summary">
            <StatCard title="Total properties" value="38" pill="+3 this month" />
            <StatCard
              title="Total prospective tenants"
              value="412"
              pill="+24 active leases"
            />
            <div className="dash-card dash-card--stat">
              <div className="dash-card-header">
                <p className="dash-card-label">Rent collection</p>
                <span className="dash-pill dash-pill--success">92.6% collected</span>
              </div>
              <div className="dash-rent-row">
                <div className="dash-rent-amount">
                  <span className="dash-rent-label">Collected</span>
                  <span className="dash-rent-value">$184,300</span>
                </div>
                <div className="dash-rent-meter">
                  <div className="dash-rent-meter-track">
                    <div className="dash-rent-meter-fill" />
                  </div>
                  <span className="dash-rent-caption">Due: $199,000</span>
                </div>
              </div>
            </div>
            <div className="dash-card dash-card--stat">
              <div className="dash-card-header">
                <p className="dash-card-label">Pending maintenance</p>
                <span className="dash-pill dash-pill--alert">7 open</span>
              </div>
              <div className="dash-maintenance-list">
                <div className="dash-maint-item">
                  <span className="dot dot--warning" />
                  <span>3 urgent within 24h</span>
                </div>
                <div className="dash-maint-item">
                  <span className="dot dot--muted" />
                  <span>4 scheduled this week</span>
                </div>
              </div>
            </div>
          </div>

          {/* Chart + quick links */}
          <div className="dash-grid dash-grid--primary">
            <section className="dash-card dash-card--chart">
              <div className="dash-card-header">
                <p className="dash-card-label">Occupancy & rent trend</p>
                <span className="dash-card-caption">Last 6 months</span>
              </div>
              <div className="dash-chart">
                <div className="dash-chart-ylabels">
                  <span>100%</span>
                  <span>80%</span>
                  <span>60%</span>
                  <span>40%</span>
                </div>
                <div className="dash-chart-body">
                  <div className="dash-chart-bg" />
                  <svg
                    className="dash-chart-svg"
                    viewBox="0 0 100 40"
                    preserveAspectRatio="none"
                  >
                    <defs>
                      <linearGradient id="areaFill" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="rgba(37,99,235,0.32)" />
                        <stop offset="100%" stopColor="rgba(191,219,254,0.02)" />
                      </linearGradient>
                    </defs>
                    {/* Area under the line */}
                    <path
                      d="M0,30 L10,26 L25,22 L40,20 L55,18 L70,16 L85,17 L100,18 L100,40 L0,40 Z"
                      fill="url(#areaFill)"
                    />
                    {/* Main trend line */}
                    <polyline
                      fill="none"
                      stroke="#2563eb"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      points="0,30 10,26 25,22 40,20 55,18 70,16 85,17 100,18"
                    />
                    {/* Accent line */}
                    <polyline
                      fill="none"
                      stroke="#38bdf8"
                      strokeDasharray="3 3"
                      strokeWidth="1.3"
                      points="0,31 10,29 25,25 40,24 55,23 70,22 85,21 100,20"
                    />
                  </svg>
                  <div className="dash-chart-xlabels">
                    <span>Jan</span>
                    <span>Feb</span>
                    <span>Mar</span>
                    <span>Apr</span>
                    <span>May</span>
                    <span>Jun</span>
                  </div>
                </div>
              </div>
            </section>

            <section className="dash-card dash-card--quick">
              <div className="dash-card-header">
                <p className="dash-card-label">Quick actions</p>
                <span className="dash-card-caption">Jump into key modules</span>
              </div>
              <div className="dash-quick-grid">
                <button
                  type="button"
                  className="dash-quick-btn"
                  onClick={() => navigate('/properties')}
                >
                  <span className="dash-quick-icon">🏢</span>
                  <span className="dash-quick-title">Properties</span>
                  <span className="dash-quick-sub">Unit map, availability</span>
                </button>
                <button
                  type="button"
                  className="dash-quick-btn"
                  onClick={() => navigate('/tenants')}
                >
                  <span className="dash-quick-icon">👥</span>
                  <span className="dash-quick-title">Prospective tenants</span>
                  <span className="dash-quick-sub">Contacts, leases</span>
                </button>
                <button
                  type="button"
                  className="dash-quick-btn"
                  onClick={() => navigate('/maintenance')}
                >
                  <span className="dash-quick-icon">🛠</span>
                  <span className="dash-quick-title">Maintenance</span>
                  <span className="dash-quick-sub">Requests, work orders</span>
                </button>
                <button
                  type="button"
                  className="dash-quick-btn"
                  onClick={() => navigate('/staff')}
                >
                  <span className="dash-quick-icon">👷</span>
                  <span className="dash-quick-title">Staff</span>
                  <span className="dash-quick-sub">Assignments, teams</span>
                </button>
                <button
                  type="button"
                  className="dash-quick-btn"
                  onClick={() => navigate('/feedback')}
                >
                  <span className="dash-quick-icon">💬</span>
                  <span className="dash-quick-title">Feedback</span>
                  <span className="dash-quick-sub">Tenant portal submissions</span>
                </button>
                <button
                  type="button"
                  className="dash-quick-btn dash-quick-btn--wide"
                  onClick={() => navigate('/analytics')}
                >
                  <span className="dash-quick-icon">📊</span>
                  <span className="dash-quick-title">Analytics</span>
                  <span className="dash-quick-sub">Reports & overview</span>
                </button>
              </div>
            </section>
          </div>
        </section>

        {/* Right column: notifications */}
        <aside className="dash-side">
          <section className="dash-card dash-card--notifications">
            <div className="dash-card-header">
              <p className="dash-card-label">Notifications</p>
              <span className="dash-pill dash-pill--muted">Today</span>
            </div>
            <ul className="dash-notify-list">
              <li className="dash-notify-item">
                <span className="dot dot--primary" />
                <div className="dash-notify-body">
                  <p className="dash-notify-title">New maintenance request</p>
                  <p className="dash-notify-sub">
                    Leaking sink reported for Unit 3B at Elm Court.
                  </p>
                </div>
                <span className="dash-notify-time">8:12 AM</span>
              </li>
              <li className="dash-notify-item">
                <span className="dot dot--success" />
                <div className="dash-notify-body">
                  <p className="dash-notify-title">Rent payment received</p>
                  <p className="dash-notify-sub">
                    $2,150 from prospective tenant #204 (Maple Heights).
                  </p>
                </div>
                <span className="dash-notify-time">7:48 AM</span>
              </li>
              <li className="dash-notify-item">
                <span className="dot dot--muted" />
                <div className="dash-notify-body">
                  <p className="dash-notify-title">Inspection scheduled</p>
                  <p className="dash-notify-sub">
                    Quarterly walkthrough for Building C, Friday 2:00 PM.
                  </p>
                </div>
                <span className="dash-notify-time">Yesterday</span>
              </li>
            </ul>
          </section>
        </aside>
      </main>
    </div>
  );
}

export default Dashboard;

